import { withStyles } from '@mui/styles';
import CourierPageBase from './CourierPageBase';
import styles from './styles';

const Styled = withStyles(styles)(CourierPageBase);

export default Styled;
